import clsx from 'clsx'
import { useField } from 'formik'
import React from 'react'

import { InputContainer } from '../Input/Input.styles'
import { TimeInput } from '.'

interface Props {
  className?: string
  endHour?: number
  label?: string
  name: string
  startHour?: number
  timeFormat?: string
  timeIntervals?: number
}

export const TimeInputControlled = ({
  className,
  endHour,
  label,
  name,
  startHour,
  timeFormat,
  timeIntervals,
}: Props) => {
  const [field, { touched, error }, { setError, setValue }] = useField({ name, type: 'time' })

  const isError = touched && !!error

  const handleChange = (value: Date) => {
    setValue(value)
    setError(undefined)
  }

  return (
    <InputContainer className={className} isError={isError}>
      {label && (
        <label className="mb-2 font-medium leading-120 text-primary" htmlFor={name}>
          {label}
        </label>
      )}
      <TimeInput
        endHour={endHour}
        handleChange={handleChange}
        startHour={startHour}
        timeFormat={timeFormat}
        timeIntervals={timeIntervals}
        value={field.value}
      />
      <div className={clsx('flex w-full', isError ? 'justify-between' : 'justify-end')}>
        {isError && <p className="mt-1 font-medium text-label-xs text-tertiary">{error}</p>}
      </div>
    </InputContainer>
  )
}
